import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableRow from '@mui/material/TableRow';
import MuiMarkdown, { getOverrides } from 'mui-markdown';
import React from 'react';
import MarkdownLink from '~/components/MarkdownLink';
import { StyledHeadingTypography, StyledOl, StyledTableCell, StyledTableHead, StyledTypography, StyledUl } from './styles';
interface IOverride {
  [key: string]: {
    component: React.ComponentType<{
      children: React.ReactNode;
    }>;
  };
}
export interface MarkdownTextProps {
  customOverrides?: IOverride;
  children: string;
}
const markdownOverrides = {
  ...getOverrides({}),
  a: {
    component: MarkdownLink
  },
  h1: {
    component: StyledHeadingTypography,
    props: {
      component: 'h1',
      variant: 'h5'
    }
  },
  h2: {
    component: StyledHeadingTypography,
    props: {
      component: 'h2',
      variant: 'h6'
    }
  },
  h3: {
    component: StyledHeadingTypography,
    props: {
      component: 'h3',
      variant: 'h6'
    }
  },
  ol: {
    component: StyledOl
  },
  p: {
    component: StyledTypography
  },
  table: {
    component: Table
  },
  tbody: {
    component: TableBody
  },
  td: {
    component: StyledTableCell
  },
  thead: {
    component: StyledTableHead
  },
  tr: {
    component: TableRow
  },
  ul: {
    component: StyledUl
  }
};
export const MarkdownText: React.FC<MarkdownTextProps> = ({
  customOverrides,
  children
}: MarkdownTextProps): React.ReactElement<MarkdownTextProps> => <MuiMarkdown overrides={{
  ...markdownOverrides,
  ...customOverrides
}} data-sentry-element="MuiMarkdown" data-sentry-component="MarkdownText" data-sentry-source-file="index.tsx">
    {children}
  </MuiMarkdown>;
export default MarkdownText;